// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"f4a2d740","477":"167fce1f","496":"0560ba77","921":"8824d42c"}[chunkId] + ".chunk.js";
};